import React from 'react'

const AuthenticationContext = React.createContext({
  jwt: null,
  signOut: null,
})
export default AuthenticationContext
